import bottom_piece1 from "@/assets/images/puzzle/bottom_piece1.svg";
import bottom_piece1_filled from "@/assets/images/puzzle/bottom_piece1_filled.svg";
import bottom_piece2 from "@/assets/images/puzzle/bottom_piece2.svg";
import bottom_piece2_filled from "@/assets/images/puzzle/bottom_piece2_filled.svg";
import left_piece1 from "@/assets/images/puzzle/left_piece1.svg";
import left_piece1_filled from "@/assets/images/puzzle/left_piece1_filled.svg";
import left_piece2 from "@/assets/images/puzzle/left_piece2.svg";
import left_piece2_filled from "@/assets/images/puzzle/left_piece2_filled.svg";
import left_right_piece1 from "@/assets/images/puzzle/left_right_piece1.svg";
import left_right_piece1_filled from "@/assets/images/puzzle/left_right_piece1_filled.svg";
import left_right_piece2 from "@/assets/images/puzzle/left_right_piece2.svg";
import left_right_piece2_filled from "@/assets/images/puzzle/left_right_piece2_filled.svg";
import piece1 from "@/assets/images/puzzle/piece1.svg";
import piece1_filled from "@/assets/images/puzzle/piece1-filled.svg";
import piece2 from "@/assets/images/puzzle/piece2.svg";
import piece2_filled from "@/assets/images/puzzle/piece2-filled.svg";
import right_piece1 from "@/assets/images/puzzle/right_piece1.svg";
import right_piece1_filled from "@/assets/images/puzzle/right_piece1_filled.svg";
import right_piece2 from "@/assets/images/puzzle/right_piece2.svg";
import right_piece2_filled from "@/assets/images/puzzle/right_piece2_filled.svg";
import top_left_piece1 from "@/assets/images/puzzle/top_left_piece1.svg";
import top_left_piece1_filled from "@/assets/images/puzzle/top_left_piece1_filled.svg";
import top_left_piece2 from "@/assets/images/puzzle/top_left_piece2.svg";
import top_left_piece2_filled from "@/assets/images/puzzle/top_left_piece2_filled.svg";
import top_left_right_piece1 from "@/assets/images/puzzle/top_left_right_piece1.svg";
import top_left_right_piece1_filled from "@/assets/images/puzzle/top_left_right_piece1_filled.svg";
import top_left_right_piece2 from "@/assets/images/puzzle/top_left_right_piece2.svg";
import top_left_right_piece2_filled from "@/assets/images/puzzle/top_left_right_piece2_filled.svg";
import top_piece1 from "@/assets/images/puzzle/top_piece1.svg";
import top_piece1_filled from "@/assets/images/puzzle/top_piece1_filled.svg";
import top_piece2 from "@/assets/images/puzzle/top_piece2.svg";
import top_piece2_filled from "@/assets/images/puzzle/top_piece2_filled.svg";
import top_right_piece1 from "@/assets/images/puzzle/top_right_piece1.svg";
import top_right_piece1_filled from "@/assets/images/puzzle/top_right_piece1_filled.svg";
import top_right_piece2 from "@/assets/images/puzzle/top_right_piece2.svg";
import top_right_piece2_filled from "@/assets/images/puzzle/top_right_piece2_filled.svg";
import bottom_left_piece1 from "@/assets/images/puzzle/bottom_left_piece1.svg";
import bottom_left_piece1_filled from "@/assets/images/puzzle/bottom_left_piece1_filled.svg";
import bottom_right_piece1 from "@/assets/images/puzzle/bottom_right_piece1.svg";
import bottom_right_piece1_filled from "@/assets/images/puzzle/bottom_right_piece1_filled.svg";
import bottom_left_piece2 from "@/assets/images/puzzle/bottom_left_piece2.svg";
import bottom_left_piece2_filled from "@/assets/images/puzzle/bottom_left_piece2_filled.svg";
import bottom_right_piece2 from "@/assets/images/puzzle/bottom_right_piece2.svg";
import bottom_right_piece2_filled from "@/assets/images/puzzle/bottom_right_piece2_filled.svg";


export const puzzleSize = { hor: 14, vert: 13 };

/** Each piece SVG draws inside its viewBox — bleed lets artwork reach the frame edge. */
export const PUZZLE_BLEED_PERCENT = 2.5;

/** Piece cell width as a multiple of grid column width (overlap for interlocking tabs). */
export const PUZZLE_PIECE_OVERLAP = 1.6;

export const tilePieceMapping: Map<string, string> = new Map([
  [
    JSON.stringify({
      left: true,
      right: false,
      top: false,
      bottom: false,
      pieceType: 0,
      active: true,
    }),
    left_piece1_filled,
  ],
  [
    JSON.stringify({
      left: true,
      right: false,
      top: false,
      bottom: false,
      pieceType: 0,
      active: false,
    }),
    left_piece1,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: false,
      bottom: false,
      pieceType: 0,
      active: true,
    }),
    right_piece1_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: false,
      bottom: false,
      pieceType: 0,
      active: false,
    }),
    right_piece1,
  ],
  [
    JSON.stringify({
      left: true,
      right: true,
      top: false,
      bottom: false,
      pieceType: 0,
      active: true,
    }),
    left_right_piece1_filled,
  ],
  [
    JSON.stringify({
      left: true,
      right: true,
      top: false,
      bottom: false,
      pieceType: 0,
      active: false,
    }),
    left_right_piece1,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: true,
      bottom: false,
      pieceType: 0,
      active: true,
    }),
    top_piece1_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: true,
      bottom: false,
      pieceType: 0,
      active: false,
    }),
    top_piece1,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: false,
      bottom: true,
      pieceType: 0,
      active: true,
    }),
    bottom_piece1_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: false,
      bottom: true,
      pieceType: 0,
      active: false,
    }),
    bottom_piece1,
  ],
  [
    JSON.stringify({
      left: true,
      right: false,
      top: true,
      bottom: false,
      pieceType: 0,
      active: true,
    }),
    top_left_piece1_filled,
  ],
  [
    JSON.stringify({
      left: true,
      right: false,
      top: true,
      bottom: false,
      pieceType: 0,
      active: false,
    }),
    top_left_piece1,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: true,
      bottom: false,
      pieceType: 0,
      active: true,
    }),
    top_right_piece1_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: true,
      bottom: false,
      pieceType: 0,
      active: false,
    }),
    top_right_piece1,
  ],
  [
    JSON.stringify({
      left: true,
      right: true,
      top: true,
      bottom: false,
      pieceType: 0,
      active: true,
    }),
    top_left_right_piece1_filled,
  ],
  [
    JSON.stringify({
      left: true,
      right: true,
      top: true,
      bottom: false,
      pieceType: 0,
      active: false,
    }),
    top_left_right_piece1,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: false,
      bottom: false,
      pieceType: 0,
      active: true,
    }),
    piece1_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: false,
      bottom: false,
      pieceType: 0,
      active: false,
    }),
    piece1,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: false,
      bottom: false,
      pieceType: 1,
      active: true,
    }),
    piece2_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: false,
      bottom: false,
      pieceType: 1,
      active: false,
    }),
    piece2,
  ],
  [
    JSON.stringify({
      left: true,
      right: false,
      top: false,
      bottom: false,
      pieceType: 1,
      active: true,
    }),
    left_piece2_filled,
  ],
  [
    JSON.stringify({
      left: true,
      right: false,
      top: false,
      bottom: false,
      pieceType: 1,
      active: false,
    }),
    left_piece2,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: false,
      bottom: false,
      pieceType: 1,
      active: true,
    }),
    right_piece2_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: false,
      bottom: false,
      pieceType: 1,
      active: false,
    }),
    right_piece2,
  ],
  [
    JSON.stringify({
      left: true,
      right: true,
      top: false,
      bottom: false,
      pieceType: 1,
      active: true,
    }),
    left_right_piece2_filled,
  ],
  [
    JSON.stringify({
      left: true,
      right: true,
      top: false,
      bottom: false,
      pieceType: 1,
      active: false,
    }),
    left_right_piece2,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: true,
      bottom: false,
      pieceType: 1,
      active: true,
    }),
    top_piece2_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: true,
      bottom: false,
      pieceType: 1,
      active: false,
    }),
    top_piece2,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: false,
      bottom: true,
      pieceType: 1,
      active: true,
    }),
    bottom_piece2_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: false,
      top: false,
      bottom: true,
      pieceType: 1,
      active: false,
    }),
    bottom_piece2,
  ],
  [
    JSON.stringify({
      left: true,
      right: false,
      top: true,
      bottom: false,
      pieceType: 1,
      active: true,
    }),
    top_left_piece2_filled,
  ],
  [
    JSON.stringify({
      left: true,
      right: false,
      top: true,
      bottom: false,
      pieceType: 1,
      active: false,
    }),
    top_left_piece2,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: true,
      bottom: false,
      pieceType: 1,
      active: true,
    }),
    top_right_piece2_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: true,
      bottom: false,
      pieceType: 1,
      active: false,
    }),
    top_right_piece2,
  ],
  [
    JSON.stringify({
      left: true,
      right: true,
      top: true,
      bottom: false,
      pieceType: 1,
      active: true,
    }),
    top_left_right_piece2_filled,
  ],
  [
    JSON.stringify({
      left: true,
      right: true,
      top: true,
      bottom: false,
      pieceType: 1,
      active: false,
    }),
    top_left_right_piece2,
  ],
  [
    JSON.stringify({
      left: true,
      right: false,
      top: false,
      bottom: true,
      pieceType: 0,
      active: true,
    }),
    bottom_left_piece1_filled,
  ],
  [
    JSON.stringify({
      left: true,
      right: false,
      top: false,
      bottom: true,
      pieceType: 0,
      active: false,
    }),
    bottom_left_piece1,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: false,
      bottom: true,
      pieceType: 0,
      active: true,
    }),
    bottom_right_piece1_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: false,
      bottom: true,
      pieceType: 0,
      active: false,
    }),
    bottom_right_piece1,
  ],
  [
    JSON.stringify({
      left: true,
      right: false,
      top: false,
      bottom: true,
      pieceType: 1,
      active: true,
    }),
    bottom_left_piece2_filled,
  ],
  [
    JSON.stringify({
      left: true,
      right: false,
      top: false,
      bottom: true,
      pieceType: 1,
      active: false,
    }),
    bottom_left_piece2,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: false,
      bottom: true,
      pieceType: 1,
      active: true,
    }),
    bottom_right_piece2_filled,
  ],
  [
    JSON.stringify({
      left: false,
      right: true,
      top: false,
      bottom: true,
      pieceType: 1,
      active: false,
    }),
    bottom_right_piece2,
  ],
]);

/**
 * Returns the SVG path for a puzzle piece at (x, y).
 * @param filled - true → solid piece (fog opacity is visible)
 *                 false → outline / hollow variant
 */
export function getPuzzlePieceImage(x: number, y: number, filled = true): string {
  const pieceType = (x + y) % 2;

  const flatSides = {
    left: x === 0,
    right: x === puzzleSize.hor - 1,
    top: y === 0,
    bottom: y === puzzleSize.vert - 1,
  };

  const key = JSON.stringify({ ...flatSides, pieceType, active: filled });
  const image = tilePieceMapping.get(key);

  if (!image) {
    const defaultKey = JSON.stringify({
      left: false, right: false, top: false, bottom: false,
      pieceType, active: filled,
    });
    return tilePieceMapping.get(defaultKey) || "";
  }

  return image;
}

